/* eslint import/no-unresolved: 0 */
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { ActionRow, Chip } from '@openedx/paragon';
import { Locked } from '@openedx/paragon/icons';

import SectionTitle from '@src/course-home/outline-tab/section-outline/SectionTitle.tsx';
import messages from './messages';

const SectionHeader = ({
  complete,
  hasLockedContent,
  hideFromTOC,
  title,
  upgradeUrl,
}) => {
  const intl = useIntl();

  return (
    <ActionRow>
      <SectionTitle {...{ complete, hideFromTOC, title }} />
      <ActionRow.Spacer />
      {hasLockedContent && (
        <Chip
          onClick={() => window.open(upgradeUrl)}
          iconBefore={Locked}
        >
          <span className="small font-weight-normal">
            {intl.formatMessage(messages.sectionChipText)}
          </span>
        </Chip>
      )}
    </ActionRow>
  );
};

SectionHeader.propTypes = {
  complete: PropTypes.bool.isRequired,
  hasLockedContent: PropTypes.bool.isRequired,
  hideFromTOC: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  upgradeUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
};

export default SectionHeader;
